import request from '@/utils/request'; //引入封装好的 axios 请求

export function superviseLogin() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //登录接口
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/login',
    method: 'post',
    data: data
  });
}
export function user() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //企业、根据code获取用户信息苏商通
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/SST_LOGIN',
    method: 'post',
    data: data
  });
}
export function zxBankLogin() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/user/zxBankLogin',
    method: 'post',
    params: data
  });
}
export function Login() {
  //金融机构根据token获取用户信息
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/queryUserInfoByToken',
    method: 'post',
    data: {//提交的数据
    }
  });
}
export function LoginOut() {
  //企业和金融机构根据token获取用户信息
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/login_out',
    method: 'post',
    data: {//提交的数据
    }
  });
}
export function Register() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //审核人和监管机构注册/银行与信用注册
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/register',
    method: 'post',
    data: data
  });
}
export function getRoleInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //审核人和监管机构注册
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/getRoleInfo',
    method: 'post',
    data: data
  });
} // 获取银行信息

export function getBankInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/financial/selectInfoList',
    method: 'post',
    data: data
  });
} // 获取金融机构银行信息

export function getfinBankInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/loanInfo/selectBranchBankList',
    method: 'post',
    data: data
  });
}
export function selectNewDemand() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/demand/selectNewDemand',
    method: 'get',
    params: data
  });
}
export function getSmsSend() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  //获取短信验证码
  return request({
    //使用封装好的 axios 进行网络请求
    url: '/api/v1/user/getSmsSend',
    method: 'post',
    data: data
  });
}